module.exports = __webpack_public_path__ + "img/not-authorized-dark.5c578260.svg";